<template>
<div
  :class="$props.whatsPosicao"
  class="payt-whats-fixed-btn resizable-font">
  <div v-if="$props.capturarDados == 'S'">
    <div
      v-if="showcontent"
      class="close-botao-ws"
      @click="showcontent = !showcontent">
      x
    </div>
    <div
      class="text-center bloco-ws-title"
      @click="showcontent = !showcontent">
      <i
        class="fa-brands fa-whatsapp"
        style="margin-right: 5px;" />{{ $props.textoBotao }}
    </div>
    <div
      ref="wsContent"
      :class="{'bloco-ws-msg-open': showcontent, 'bloco-ws-msg-close': !showcontent}"
      class="bloco-ws-msg">
      <div class="balao-msg">
        {{ $props.textoChamada }}
      </div>
      <div class="bloco-ws-contato">
        <label
          for="nome"
          class="mt-3 mb-1">Nome:</label>
        <div class="format-ws-input">
          <input
            v-model="contato.nome"
            type="text"
            name="nome"
            placeholder="Inserir o nome"
            @blur="disabledButton">
        </div>
        <label
          for="email"
          class="mt-3 mb-1">Seu e-mail:</label>
        <div class="format-ws-input">
          <input
            v-model="contato.email"
            type="email"
            name="email"
            placeholder="Inserir e-mail"
            @blur="disabledButton">
        </div>
        <label
          for="telefone"
          class="mt-3 mb-1">Número de contato:</label>
        <div class="format-ws-input">
          <input
            id="field_tel_new_store_desktop"
            v-model="contato.telefone"
            type="tel"
            name=""
            style="color: #363636 !important;"
            @blur="disabledButton"
            @input="contato.telefone = contato.telefone.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');">
          <small
            id="phoneInternationalErrorNewStoreDesktop"
            class="help-block"
            style="color:red; display:none;">Número inválido</small>
          <input
            id="telefone_ddi_new_store_desktop"
            v-model="contato.ddi"
            type="hidden"
            name="cliente_ddi">
          <input
            id="field_phone_hidden"
            type="hidden"
            :value="contato.telefone">
        </div>
        <div
          class="button-ws mt-3"
          @click="enviarContato()">
          <span style="color: #FFF;">Iniciar conversa</span>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="$props.capturarDados == 'N'"
    class="text-center bloco-ws-title"
    @click="enviarContato()">
    <i
      class="fa-brands fa-whatsapp"
      style="margin-right: 5px;" />{{ $props.textoBotao }}
  </div>
</div>
</template>
<script>
export default {
  props:[
    'textoBotao',
    'textoChamada',
    'whatsNumero',
    'textoWhatsappCliente',
    'whatsPosicao',
    'capturarDados'
  ],
  data() {
    return {
      contato: {
        nome: null,
        email: null,
        telefone: null,
        ddi: null,
      },
      showcontent: false,
    };
  },
  mounted(){
    window.addEventListener('load', ()=> {
      $('.button-ws').addClass('disabledbutton');
      const input = document.querySelector('#field_tel_new_store_desktop');
            
      window.intlTelInput(input, {
        utilsScript:'/assets/lojas/plugins/international-telephone-input/js/utils.js',
        separateDialCode: true
      });

      const iti = window.intlTelInputGlobals.getInstance(input);
      iti.setCountry('br');

      this.updateDDI();
      input.addEventListener('countrychange', this.updateDDI);
      input.addEventListener('change', this.validarTelefone);
    });
  },
  methods:{
    disabledButton(){
      for(let key of Object.keys(this.contato)){
        if(this.contato['nome'] && this.contato['email'] && this.contato['telefone']){
          $('.button-ws').removeClass('disabledbutton');
        }else{
          $('.button-ws').addClass('disabledbutton');
        }  
      }
    },
    updateDDI(){
      const input = document.querySelector('#field_tel_new_store_desktop');
      const iti = window.intlTelInputGlobals.getInstance(input);
      const ddi = iti.getSelectedCountryData().dialCode;

      const inputDDI = document.querySelector('#telefone_ddi_new_store_desktop');
      inputDDI.value = ddi;
      this.contato.ddi = ddi;
    },
    validarTelefone(){
      const input = document.querySelector('#field_tel_new_store_desktop');
      const iti = window.intlTelInputGlobals.getInstance(input);

      if(iti.isValidNumber()) { // Válido
        input.style.borderColor = '#3c763d';
        document.querySelector('#phoneInternationalErrorNewStoreDesktop').style.display = 'none';
        iti.setNumber(iti.getNumber()); // Aplicando formatação
        return true;
      } else { // Inválido
        input.style.borderColor = '#F00';
        document.querySelector('#phoneInternationalErrorNewStoreDesktop').style.display = 'block';
        return false;
      } 
    },
    enviarContato(){
      this.$emit('iniciarConversaWs', this.contato);
      setTimeout(() => {
        this.contato.nome   = null;
        this.contato.email  = null;
        this.contato.telefone  = null;
        this.showcontent    = false;
      },1000);
    }
  }
};
</script>